import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-accent-500 uppercase tracking-wider mb-2">MEDIA GALLERY</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">精选视频</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站精选热门视频内容，盘点、专访、测评一站尽览
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaData.slice(0, 3).map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-[10px] px-2 py-0.5 rounded bg-black/70 text-white">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] font-semibold px-2 py-0.5 rounded bg-accent-100 text-accent-700">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.views} 次播放</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto mt-5">
          {mediaData.slice(3, 5).map((item, i) => (
            <div key={i + 3} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group flex flex-col sm:flex-row">
              <div className="relative w-full sm:w-48 aspect-video sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-lg ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-1 right-1 text-[10px] px-1.5 py-0.5 rounded bg-black/70 text-white">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] font-semibold px-2 py-0.5 rounded bg-accent-100 text-accent-700">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.views} 次播放</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}